/* eslint-disable @typescript-eslint/no-explicit-any */
// src/lib/security/signature.ts

export const createSignature = async (
  timestamp: number,
  method: string,
  payload: Record<string, any>
): Promise<string> => {
  const secret = process.env.NEXT_PUBLIC_SIGNATURE_KEY;

  if (!secret) {
    throw new Error("Signature key missing");
  }

  const message = `${timestamp}.${method}.${JSON.stringify(payload)}`;

  const encoder = new TextEncoder();
  const keyData = encoder.encode(secret);
  const msgData = encoder.encode(message);

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyData,
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );

  const signatureBuffer = await crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    msgData
  );

  return Array.from(new Uint8Array(signatureBuffer))
    .map(b => b.toString(16).padStart(2, "0"))
    .join("");
};
